import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from './components/Layout';
import { About } from './pages/About';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Booking } from './pages/Booking';
import { Contact } from './pages/Contact';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { Pricing } from './pages/Pricing';
import { Projects } from './pages/Projects';
import { Services } from './pages/Services';
import { AIServices } from './pages/services/AIServices';
import { AutomationServices } from './pages/services/AutomationServices';
import { HomelabServices } from './pages/services/HomelabServices';
import { InfrastructureServices } from './pages/services/InfrastructureServices';
import { NetworkWifiServices } from './pages/services/NetworkWifiServices';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <NotFound />,
    children: [
      { index: true, element: <Home /> },
      { path: 'services', element: <Services /> },
      { path: 'services/automation', element: <AutomationServices /> },
      { path: 'services/infrastructure', element: <InfrastructureServices /> },
      { path: 'services/ai-systems', element: <AIServices /> },
      { path: 'services/network-wifi', element: <NetworkWifiServices /> },
      { path: 'services/homelab', element: <HomelabServices /> },
      { path: 'pricing', element: <Pricing /> },
      { path: 'projects', element: <Projects /> },
      { path: 'blog', element: <Blog /> },
      { path: 'blog/:slug', element: <BlogPost /> },
      { path: 'about', element: <About /> },
      { path: 'contact', element: <Contact /> },
      { path: 'booking', element: <Booking /> },
      { path: '*', element: <NotFound /> }
    ]
  }
]);

export function App() {
  return <RouterProvider router={router} />;
}
